import React from "react";
import Button from "../../components/Button/Button";
import {useNavigate, useLocation} from "react-router-dom";
import market from '../../assets/images/centrum-markt-2-comp.jpg'
import event from '../../assets/images/food-truck-evenement-comp.jpg'
import publicRoad from '../../assets/images/viskraam-standplaats-comp.jpg'
import standIconWhite from "../../assets/icons/stand-white.svg"
import accountIconWhite from "../../assets/icons/account-white.svg"
import standIcon from "../../assets/icons/stand.svg"
import spotGroupIconWhite from "../../assets/icons/spot-group-white.svg"
import spotGroupIcon from "../../assets/icons/spot-group.svg"
import coffeeBarista from "../../assets/images/koffie-barista-comp.jpg";
import coffeeIcon from "../../assets/icons/coffee-white.svg";
import checkIcon from "../../assets/icons/check.svg";
//import './style.scss'

const HowItWorks = () => {

  const navigate = useNavigate()
  const location = useLocation()

  const handleClickMarked = (e) => {
    e.preventDefault()
    navigate('/?search_model=spot_group&types=1')
  }

  const handleClickEvent = (e) => {
    e.preventDefault()
    navigate('/?search_model=spot_group&types=3')
  }

  const handleClickPublic = (e) => {
    e.preventDefault()
    navigate('/?search_model=spot_group&types=32')
  }

  return (
    <div className="page-how-it-works">

      {/* Hero Section */}
      <section className="hero">
        <div className="section-container">
          <h1>Hoe werkt Standplaats.nl?</h1>
          <p className="subtitle">
            Het platform dat mobiele ondernemers en locatie-eigenaren met elkaar verbindt.
            Vind de perfecte standplaats of bereik de juiste ondernemers - snel en eenvoudig.
          </p>
        </div>
      </section>

      {/* Two Types Intro */}
      <section className="two-types-intro">
        <div className="section-container">
          <h2>Twee soorten profielen op Standplaats.nl</h2>
          <p className="intro-text">
            Op Standplaats.nl zijn er twee type gebruikers. Bekijk hieronder welke bij jou past:
          </p>
          <div className="type-cards">
            <div className="type-card stand">
              <div className="card-header">
                <img src={standIcon} alt="Stand of truck" className="type-icon"/>
                <h3>Stand of Truck</h3>
              </div>
              <p className="type-description">
                Ben jij een ondernemer met een foodtruck, marktkraam, of mobiele onderneming?
                Dan is dit profiel voor jou.
              </p>
              <Button
                label="Dit ben ik"
                icon={standIconWhite}
                color="green"
                onClick={() => document.getElementById('stand-section').scrollIntoView({behavior: 'smooth'})}
              />
            </div>
            <div className="type-card location">
              <div className="card-header">
                <img src={spotGroupIcon} alt="Locatie" className="type-icon"/>
                <h3>Locatie</h3>
              </div>
              <p className="type-description">
                Heb jij een markt, evenement, winkel of andere locatie met ruimte voor stands?
                Dan is dit profiel voor jou.
              </p>
              <Button
                label="Dit ben ik"
                icon={spotGroupIconWhite}
                color="blue"
                onClick={() => document.getElementById('location-section').scrollIntoView({behavior: 'smooth'})}
              />
            </div>
          </div>
          <div className="quick-book">
            <br/>
            <strong>Geen profiel nodig?</strong> Wil je alleen een stand inhuren?
            Maak een gratis account aan en boek direct.
            <p>
              <Button
                  label="Bekijk beschikbare stands"
                  icon={standIconWhite}
                  color="grey"
                  link="/?direction=search&search_model=stand"
              />
            </p>

          </div>
        </div>
      </section>

      {/* Stand/Truck Section */}
      <section className="profile-section stand-section" id="stand-section">
        <div className="section-container">
          <div className="section-header">
            <img src={standIcon} alt="Stand of truck" className="section-icon"/>
            <div>
              <h2>Voor Stands & Trucks</h2>
              <p className="section-subtitle">Foodtrucks, marktkramen, ambulante handelaren & mobiele ondernemers</p>
            </div>
          </div>

          <div className="content-grid">
            <div className="info-block">
              <h3>Wie ben je?</h3>
              <ul className="who-list">
                <li>Foodtruck eigenaar</li>
                <li>Marktkraam / standhouder</li>
                <li>Ambulante handelaar</li>
                <li>Mobiele ondernemer (ijsverkoper, bloemenkraam, etc.)</li>
                <li>Artiesten & acts</li>
              </ul>
            </div>

            <div className="info-block">
              <h3>Wat kun je doen?</h3>
              <div className="feature-list">
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Gratis profiel aanmaken</strong>
                    <p>Maak een profiel met foto's en beschrijving zodat locaties jou kunnen vinden en uitnodigen.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Standplaatsen zoeken & boeken</strong>
                    <p>Zoek op locatie, type (markt, evenement, winkelcentrum) en datum. Stuur een boekingsverzoek.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Boekingsverzoeken ontvangen</strong>
                    <p>Locaties kunnen jou uitnodigen voor hun markt of evenement. Accepteer of weiger met één klik.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Berichten sturen & ontvangen</strong>
                    <p>Communiceer direct met locaties via het berichtensysteem. Stel vragen of maak afspraken.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="steps-block">
            <h3>Hoe werkt het?</h3>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <strong>Maak gratis een account aan</strong>
                  <p>Registreer en maak een profiel voor je stand of truck.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <strong>Zoek of word gevonden</strong>
                  <p>Zoek zelf naar standplaatsen, of laat locaties jou vinden via je profiel.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <strong>Boek en bevestig</strong>
                  <p>Stuur of ontvang een boekingsverzoek. Na acceptatie is je plek gereserveerd.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="example-block">
            <h3>Voorbeeld</h3>
            <div className="example-card">
              <p>
                <em>"Jan heeft een foodtruck met Italiaanse gerechten. Via Standplaats.nl zoekt hij naar
                evenementen in zijn regio. Hij vindt een muziekfestival in Utrecht dat nog een food corner
                zoekt. Jan stuurt een boekingsverzoek met zijn menukaart. Binnen 2 dagen is zijn plek bevestigd
                en kan hij zich voorbereiden op het festival."</em>
              </p>
            </div>
          </div>

          <div className="cta-block">
            <h3>Start vandaag nog</h3>
            <div className="cta-buttons">
              <Button
                label="Gratis profiel aanmaken"
                icon={standIconWhite}
                color="green"
                link="/wizard/welkom/start"
                linkState={{
                  buttonPrev: {
                    start: {
                      onClick: {navigate: location.pathname},
                      className: 'btn-color-red',
                      label: 'Terug',
                    }
                  }
                }}
              />
              <Button
                label="Bekijk beschikbare standplaatsen"
                icon={spotGroupIconWhite}
                color="grey"
                link="/?direction=search&search_model=spot_group"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Location Types Browse */}
      <section className="browse-locations">
        <div className="section-container">
          <h2>Zoek standplaatsen op type locatie</h2>
          <div className="location-cards">
            <a className="location-card" onClick={handleClickMarked} href="/?search_model=spot_group&types=1">
              <img src={market} alt="Markt"/>
              <div className="card-content">
                <h3>Markten</h3>
                <p>Weekmarkten, boerenmarkten, themamarkten</p>
              </div>
            </a>
            <a className="location-card" onClick={handleClickEvent} href="/?search_model=spot_group&types=3">
              <img src={event} alt="Evenement"/>
              <div className="card-content">
                <h3>Evenementen</h3>
                <p>Festivals, braderieen, kermissen</p>
              </div>
            </a>
            <a className="location-card" onClick={handleClickPublic} href="/?search_model=spot_group&types=32">
              <img src={publicRoad} alt="Openbare weg"/>
              <div className="card-content">
                <h3>Openbare ruimte</h3>
                <p>Vaste standplaatsen op straat of pleinen</p>
              </div>
            </a>
          </div>
          <p className="more-text">
            En nog veel meer: winkelcentra, bedrijventerreinen, campings, tankstations, parkeerplaatsen...
          </p>
        </div>
      </section>

      {/* Location Section */}
      <section className="profile-section location-section" id="location-section">
        <div className="section-container">
          <div className="section-header">
            <img src={spotGroupIcon} alt="Locatie" className="section-icon"/>
            <div>
              <h2>Voor Locaties</h2>
              <p className="section-subtitle">Markten, evenementen, winkels, bedrijventerreinen & gemeentes</p>
            </div>
          </div>

          <div className="content-grid">
            <div className="info-block">
              <h3>Wie ben je?</h3>
              <ul className="who-list">
                <li>Marktmeester of marktorganisator</li>
                <li>Evenementenorganisator (festival, braderie)</li>
                <li>Winkeleigenaar met ruimte buiten</li>
                <li>Beheerder bedrijventerrein of parkeerplaats</li>
                <li>Gemeente of overheidsinstantie</li>
              </ul>
            </div>

            <div className="info-block">
              <h3>Wat kun je doen?</h3>
              <div className="feature-list">
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Standplaatsen aanbieden</strong>
                    <p>Plaats je locatie met beschikbare plekken. Stel prijzen, voorwaarden en beschikbaarheid in.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Stands & trucks zoeken en uitnodigen</strong>
                    <p>Blader door profielen van ondernemers en stuur een boekingsverzoek voor jouw locatie.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Boekingsverzoeken ontvangen</strong>
                    <p>Stands en trucks kunnen jou vinden en een aanvraag sturen. Accepteer of weiger met één klik.</p>
                  </div>
                </div>
                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Berichten sturen & ontvangen</strong>
                    <p>Communiceer direct met standhouders via het berichtensysteem. Stel vragen of maak afspraken.</p>
                  </div>
                </div>

                <div className="feature">
                  <img src={checkIcon} alt="" className="check-icon"/>
                  <div>
                    <strong>Compleet beheer dashboard</strong>
                    <p>Overzicht van alle boekingen, standplaatsen en bezetting. Beheer je plattegrond en houd bij wie waar staat.</p>
                  </div>
                </div>



              </div>
            </div>
          </div>

          <div className="steps-block">
            <h3>Hoe werkt het?</h3>
            <div className="steps">
              <div className="step">
                <div className="step-number">1</div>
                <div className="step-content">
                  <strong>Registreer je locatie</strong>
                  <p>Maak een account en voeg je locatie toe met foto's, beschrijving en beschikbare standplaatsen.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <div className="step-content">
                  <strong>Ontvang aanvragen of nodig uit</strong>
                  <p>Stands vinden jou via de zoekfunctie, of jij zoekt zelf naar de perfecte ondernemers.</p>
                </div>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <div className="step-content">
                  <strong>Beheer je boekingen</strong>
                  <p>Accepteer aanvragen, communiceer met standhouders en houd je bezetting bij.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="example-block">
            <h3>Voorbeeld</h3>
            <div className="example-card">
              <p>
                <em>"Lisa organiseert een wekelijkse boerenmarkt. Ze plaatst haar markt op Standplaats.nl met
                15 beschikbare plekken. Binnen een week ontvangt ze 8 aanvragen van lokale boeren en foodtrucks.
                Ze selecteert een mooie mix van producten en bevestigt de boekingen. Voor de resterende plekken
                zoekt ze zelf naar een visboer en kaasboer in de omgeving."</em>
              </p>
            </div>
          </div>

          <div className="benefits-block">
            <h3>Voordelen voor locaties</h3>
            <div className="benefits-grid">
              <div className="benefit">
                <strong>Groter bereik</strong>
                <p>Bereik duizenden mobiele ondernemers in heel Nederland</p>
              </div>
              <div className="benefit">
                <strong>Maximale bezetting</strong>
                <p>Vul lege plekken op en vergroot je omzet</p>
              </div>
              <div className="benefit">
                <strong>Volledige controle</strong>
                <p>Jij bepaalt wie je accepteert en onder welke voorwaarden</p>
              </div>
              <div className="benefit">
                <strong>Alleen betalen bij succes</strong>
                <p>Je betaalt alleen commissie bij een geaccepteerde boeking</p>
              </div>
            </div>
          </div>

          <div className="cta-block">
            <h3>Start vandaag nog</h3>
            <div className="cta-buttons">
              <Button
                label="Locatie aanmelden"
                icon={spotGroupIconWhite}
                color="blue"
                link="/wizard/welkom/start"
                linkState={{
                  buttonPrev: {
                    start: {
                      onClick: {navigate: location.pathname},
                      className: 'btn-color-red',
                      label: 'Terug',
                    }
                  }
                }}
              />
              <Button
                label="Bekijk beschikbare stands & trucks"
                icon={standIconWhite}
                color="grey"
                link="/?direction=search&search_model=stand"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="section-container">
          <h2>Veelgestelde vragen</h2>
          <div className="faq-list">
            <div className="faq-item">
              <h4>Wat is standplaats.nl?</h4>
              <p>Standplaats.nl is een tussenpartij. Wij maken het mogelijk voor jou om een profiel aan te maken waarmee jij in contact kan komen met locaties, standplaats houders en stand eigenaren.</p>
            </div>
            <div className="faq-item">
              <h4>Is aanmelden gratis?</h4>
              <p>Ja, aanmelden en een profiel aanmaken is helemaal gratis. Je betaalt alleen bij een succesvolle boeking.</p>
            </div>
            <div className="faq-item">
              <h4>Kan ik zowel een stand als een locatie hebben?</h4>
              <p>Ja, je kunt met een account zowel stands/trucks als locaties beheren. Handig als je bijvoorbeeld
                 een eigen foodtruck hebt maar ook een evenement organiseert.</p>
            </div>
            <div className="faq-item">
              <h4>Hoe werkt betalen?</h4>
              <p>Locaties bepalen zelf de prijs voor hun standplaatsen. Bij een geaccepteerde boeking
                 wordt een kleine commissie in rekening gebracht.</p>
            </div>
            <div className="faq-item">
              <h4>Heb ik vergunningen nodig?</h4>
              <p>Dat hangt af van het type locatie en je onderneming. Check altijd lokale regelgeving.
                 Veel locaties op Standplaats.nl hebben al de benodigde vergunningen geregeld.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact">
        <div className="section-container">
          <div className="content">
            <div className="row">
              <div className="col img">
                <img src={coffeeBarista} alt=""/>
              </div>
              <div className="col text">
                <h3>Vragen of hulp nodig?</h3>
                <p>We helpen je graag op weg. Neem contact op en we bespreken de mogelijkheden.</p>
                <Button
                  label="Neem contact op"
                  icon={coffeeIcon}
                  linkOutside={'/service/contact/'}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  )
}

export default HowItWorks
